<!--https://keenthemes.com/keen/?page=docs&section=wizard-->
<template>
  <div class="card card-custom">
    <div class="card-body p-0">
      <!--begin: Wizard-->
      <div
        class="wizard wizard-1"
        data-wizard-clickable="true"
        data-wizard-state="step-first"
        id="kt_wizard_v1"
      >
        <!--begin: Wizard Nav-->
        <div class="wizard-nav border-bottom">
          <div class="wizard-steps p-8 p-lg-10">
            <div
              class="wizard-step"
              data-wizard-state="current"
              data-wizard-type="step"
            >
              <div class="wizard-label">
                <i class="wizard-icon flaticon-list"></i>
                <h3 class="wizard-title">1. My Name and Contact</h3>
              </div>
              <i class="wizard-arrow flaticon2-next"></i>
            </div>
            <div class="wizard-step" data-wizard-type="step">
              <div class="wizard-label">
                <i class="wizard-icon flaticon-map-location"></i>
                <h3 class="wizard-title">2. My Address</h3>
              </div>
              <i class="wizard-arrow flaticon2-next"></i>
            </div>
            <div class="wizard-step" data-wizard-type="step">
              <div class="wizard-label">
                <i class="wizard-icon flaticon2-map"></i>
                <h3 class="wizard-title">3. My Property</h3>
              </div>
            </div>
          </div>
        </div>
        <!--end: Wizard Nav-->

        <!--begin: Wizard Body-->
        <div class="row justify-content-center my-10 px-8 my-lg-15 px-lg-10">
          <div class="col-xl-12 col-xxl-7">
            <!--begin: Wizard Form-->
            <!--            <form class="form" id="kt_form">-->
            <b-form class="form">
              <!--begin: My Name & Contact-->
              <div
                class="pb-5"
                data-wizard-state="current"
                data-wizard-type="step-content"
              >
                <h4 class="mb-10 font-weight-bold text-dark">
                  Enter your name and contact details
                </h4>
                <div class="row">
                  <div class="col-xl-6">
                    <b-form-group
                      class="col-lg-12 col-12"
                      label="First Name"
                      label-for="FirstName"
                    >
                      <b-form-input
                        :state="validateState('FirstName')"
                        aria-describedby="FirstName-live-feedback"
                        class="form-control-solid"
                        id="FirstName"
                        name="FirstName"
                        placeholder="First Name"
                        v-model="$v.form.FirstName.$model"
                      ></b-form-input>
                      <b-form-invalid-feedback id="FirstName-live-feedback">
                        First Name is required.
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </div>
                  <div class="col-xl-6">
                    <b-form-group
                      class="col-lg-12 col-12"
                      label="Last Name"
                      label-for="LastName"
                    >
                      <b-form-input
                        :state="validateState('LastName')"
                        aria-describedby="LastName-live-feedback"
                        class="form-control-solid"
                        id="LastName"
                        name="LastName"
                        placeholder="Last Name"
                        v-model="$v.form.LastName.$model"
                      ></b-form-input>
                      <b-form-invalid-feedback id="LastName-live-feedback">
                        Last Name is required.
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-6">
                    <b-form-group
                      class="col-lg-12 col-12"
                      label="Contact Number"
                      label-for="ContactNumber"
                    >
                      <b-form-input
                        :state="validateState('ContactNumber')"
                        aria-describedby="ContactNumber-live-feedback"
                        class="form-control-solid"
                        id="ContactNumber"
                        name="ContactNumber"
                        placeholder="ContactNumber"
                        v-model="$v.form.ContactNumber.$model"
                      ></b-form-input>
                      <b-form-invalid-feedback id="ContactNumber-live-feedback">
                        Contact Number is required.
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </div>
                  <div class="col-xl-6">
                    <b-form-group
                      class="col-lg-12 col-12"
                      label="Email"
                      label-for="Email"
                    >
                      <b-form-input
                        :state="validateState('Email')"
                        aria-describedby="Email-live-feedback"
                        class="form-control-solid"
                        id="Email"
                        name="Email"
                        placeholder="Email"
                        v-model="$v.form.Email.$model"
                      ></b-form-input>
                      <b-form-invalid-feedback id="Email-live-feedback">
                        Email is required and must be a valid email address.
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </div>
                </div>
              </div>
              <!--end: Name & Contact-->
              <!--begin: MyAddress-->
              <div class="pb-5" data-wizard-type="step-content">
                <h3 class="mb-10 font-weight-bold text-dark">
                  Enter your address
                </h3>
                <div class="row">
                  <div class="col-xl-12">
                    <b-form-group
                      class="col-lg-12 col-12"
                      label="Street"
                      label-for="AddressStreet"
                    >
                      <b-form-input
                        :state="validateState('AddressStreet')"
                        aria-describedby="AddressStreet-live-feedback"
                        class="form-control-solid"
                        id="AddressStreet"
                        name="AddressStreet"
                        placeholder="Street"
                        v-model="$v.form.AddressStreet.$model"
                      ></b-form-input>
                      <b-form-invalid-feedback id="AddressStreet-live-feedback">
                        Street is required.
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-6">
                    <b-form-group
                      class="col-lg-12 col-12"
                      label="City"
                      label-for="AddressCity"
                    >
                      <b-form-input
                        :state="validateState('AddressCity')"
                        aria-describedby="AddressCity-live-feedback"
                        class="form-control-solid"
                        id="AddressCity"
                        name="AddressCity"
                        placeholder="City"
                        v-model="$v.form.AddressCity.$model"
                      ></b-form-input>
                      <b-form-invalid-feedback id="AddressCity-live-feedback">
                        City is required.
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </div>
                  <div class="col-xl-6">
                    <b-form-group
                      class="col-lg-12 col-12"
                      label="Province"
                      label-for="AddressProvince"
                    >
                      <b-form-input
                        :state="validateState('AddressProvince')"
                        aria-describedby="AddressProvince-live-feedback"
                        class="form-control-solid"
                        id="AddressProvince"
                        name="AddressProvince"
                        placeholder="Province"
                        v-model="$v.form.AddressProvince.$model"
                      ></b-form-input>
                      <b-form-invalid-feedback
                        id="AddressProvince-live-feedback"
                      >
                        Province is required.
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-6">
                    <b-form-group
                      class="col-lg-12 col-12"
                      label="Zip Code"
                      label-for="AddressZipCode"
                    >
                      <b-form-input
                        :state="validateState('AddressZipCode')"
                        aria-describedby="AddressZipCode-live-feedback"
                        class="form-control-solid"
                        id="AddressZipCode"
                        name="AddressZipCode"
                        placeholder="Zip Code"
                        v-model="$v.form.AddressZipCode.$model"
                      ></b-form-input>
                      <b-form-invalid-feedback
                        id="AddressZipCode-live-feedback"
                      >
                        Zip Code is required.
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </div>
                </div>
              </div>
              <!--end: Address-->
              <!--begin: MyProperty-->
              <div class="pb-5" data-wizard-type="step-content">
                <h3 class="mb-10 font-weight-bold text-dark">
                  Enter your Property Unit Details
                </h3>
                <div class="row">
                  <div class="col-xl-6">
                    <b-form-group
                      class="col-lg-12 col-12"
                      label="Property Identification Number (PIN)"
                      label-for="PropertyIdentificationNumber"
                    >
                      <b-form-input
                        :state="validateState('PropertyIdentificationNumber')"
                        aria-describedby="PropertyIdentificationNumber-live-feedback"
                        class="form-control-solid"
                        id="PropertyIdentificationNumber"
                        name="PropertyIdentificationNumber"
                        placeholder="Property Identification Number (PIN)"
                        v-model="$v.form.PropertyIdentificationNumber.$model"
                      ></b-form-input>
                      <b-form-invalid-feedback
                        id="PropertyIdentificationNumber-live-feedback"
                      >
                        Property Identification Number is required.
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </div>
                  <div class="col-xl-6">
                    <b-form-group
                      class="col-lg-12 col-12"
                      label="ARP Number / TDN"
                      label-for="PropertyARPNo"
                    >
                      <b-form-input
                        :state="validateState('PropertyARPNo')"
                        aria-describedby="PropertyARPNo-live-feedback"
                        class="form-control-solid"
                        id="PropertyARPNo"
                        name="PropertyARPNo"
                        placeholder="ARP Number / TDN"
                        v-model="$v.form.PropertyARPNo.$model"
                      ></b-form-input>
                      <b-form-invalid-feedback id="PropertyARPNo-live-feedback">
                        ARP Number / TDN is required.
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </div>
                </div>
                <h5 class="mb-10 font-weight-bold text-dark">Last Payment</h5>
                <div class="row">
                  <div class="col-xl-6">
                    <b-form-group
                      class="col-lg-12 col-12"
                      label="O.R. Number"
                      label-for="PropertyLastORNo"
                    >
                      <b-form-input
                        :state="validateState('PropertyLastORNo')"
                        aria-describedby="PropertyLastORNo-live-feedback"
                        class="form-control-solid"
                        id="PropertyLastORNo"
                        name="PropertyLastORNo"
                        placeholder="O.R. Number"
                        v-model="$v.form.PropertyLastORNo.$model"
                      ></b-form-input>
                      <b-form-invalid-feedback
                        id="PropertyLastORNo-live-feedback"
                      >
                        O.R. Number is required.
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </div>
                  <div class="col-xl-6">
                    <b-form-group
                      class="col-lg-12 col-12"
                      label="O.R. Date Paid"
                      label-for="PropertyLastORDate"
                    >
                      <b-form-input
                        :state="validateState('PropertyLastORDate')"
                        aria-describedby="PropertyLastORDate-live-feedback"
                        class="form-control-solid"
                        id="PropertyLastORDate"
                        name="PropertyLastORDate"
                        placeholder="O.R. Date Paid"
                        v-model="$v.form.PropertyLastORDate.$model"
                      ></b-form-input>
                      <b-form-invalid-feedback
                        id="PropertyLastORDate-live-feedback"
                      >
                        O.R. Date Paid is required.
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </div>
                </div>
              </div>
              <!--end: Properties-->

              <!--begin: Wizard Actions -->
              <div class="d-flex justify-content-between border-top pt-10">
                <div class="mr-2">
                  <button
                    class="btn btn-light-primary font-weight-bold text-uppercase px-9 py-4"
                    data-wizard-type="action-prev"
                    type="button"
                  >
                    Previous
                  </button>
                </div>
                <div>
                  <button
                    class="btn btn-success font-weight-bold text-uppercase px-9 py-4"
                    ref="submit"
                    data-wizard-type="action-submit"
                    type="button"
                    v-on:click="submit"
                  >
                    Submit
                  </button>
                  <button
                    class="btn btn-primary font-weight-bold text-uppercase px-9 py-4"
                    data-wizard-type="action-next"
                    type="button"
                  >
                    Next
                  </button>
                </div>
              </div>
              <!--end: Wizard Actions -->
              <!--            </form>-->
            </b-form>
            <!--end: Wizard Form-->
          </div>
        </div>
        <!--end: Wizard Body-->
      </div>
    </div>
    <!--end: Wizard-->
  </div>
</template>

<style lang="scss">
@import "@/assets/sass/pages/wizard/wizard-1.scss";
</style>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import KTUtil from "@/assets/js/components/util";
import KTWizard from "@/assets/js/components/wizard";
import Swal from "sweetalert2";
import { validationMixin } from "vuelidate";
import {
  email,
  minLength,
  numeric,
  required,
  requiredIf
} from "vuelidate/lib/validators";
import ApiService from "@/view/pages/easyreceipt/api";

export default {
  mixins: [validationMixin],
  name: "profilewizard",
  props: {},
  data() {
    return {
      isBusy: false, //isNew: false,
      profile: null,
      form: {
        FirstName: "",
        LastName: "",
        ContactNumber: "",
        Email: "",
        AddressStreet: "",
        AddressCity: "",
        AddressProvince: "",
        AddressZipCode: "",
        PropertyIdentificationNumber: "",
        PropertyARPNo: "",
        PropertyLastORNo: "",
        PropertyLastORDate: ""
      }
    };
  },
  validations: {
    form: {
      FirstName: {
        required,
        minLength: minLength(2)
      },
      LastName: {
        required,
        minLength: minLength(2)
      },
      ContactNumber: {
        required,
        numeric
      },
      Email: {
        required,
        email
      },
      AddressStreet: {
        required,
        minLength: minLength(2)
      },
      AddressCity: {
        required,
        minLength: minLength(2)
      },
      AddressProvince: {
        required,
        minLength: minLength(2)
      },
      AddressZipCode: {
        required,
        numeric,
        minLength: minLength(2)
      },
      PropertyIdentificationNumber: {
        required: requiredIf(function(form) {
          return (
            form.PropertyARPNo !== "" ||
            form.PropertyLastORNo !== "" ||
            form.PropertyLastORDate !== ""
          );
        })
      },
      PropertyARPNo: {
        required: requiredIf(function(form) {
          return (
            form.PropertyIdentificationNumber !== "" ||
            form.PropertyLastORNo !== "" ||
            form.PropertyLastORDate !== ""
          );
        })
      },
      PropertyLastORNo: {
        required: requiredIf(function(form) {
          return (
            form.PropertyARPNo !== "" ||
            form.PropertyIdentificationNumber !== "" ||
            form.PropertyLastORDate !== ""
          );
        })
      },
      PropertyLastORDate: {
        required: requiredIf(function(form) {
          return (
            form.PropertyARPNo !== "" ||
            form.PropertyIdentificationNumber !== "" ||
            form.PropertyLastORNo !== ""
          );
        })
      }
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.setBreadcrumbs("Profile Wizard");
      this.initWizard();
      //this.$v.form.$touch();
      this.resetForm();
      this.getProfileMe()
        .then(() => {})
        .catch(() => {
          this.$router.push({ name: "dashboard" });
        });
    },
    initWizard() {
      // Initialize form wizard
      const wizard = new KTWizard("kt_wizard_v1", {
        startStep: 1,
        clickableSteps: true
      });

      // Validation before going to next page
      wizard.on("beforeNext", function(wizardObj) {
        // validate the form and use below function to stop the wizard's step
        // wizardObj.stop();
        console.log("beforeNext:", wizardObj);
      });

      wizard.on("afterNext", function(wizardObj) {
        // validate the form and use below function to stop the wizard's step
        // wizardObj.stop();
        console.log("afterNext:", wizardObj);
      });

      // Change event
      wizard.on("change", function(wizardObj) {
        console.log("change:", wizardObj);
        setTimeout(() => {
          KTUtil.scrollTop();
        }, 500);
      });
    },
    setBreadcrumbs(value) {
      let payload = [
        {
          title: "Property Tax",
          route: "/rpt"
        }
      ];
      payload.push({ title: value });
      this.$store.dispatch(SET_BREADCRUMB, payload);
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    resetForm() {
      this.form = {
        FirstName: "",
        LastName: "",
        ContactNumber: "",
        Email: "",
        AddressStreet: "",
        AddressCity: "",
        AddressProvince: "",
        AddressZipCode: "",
        PropertyIdentificationNumber: "",
        PropertyARPNo: "",
        PropertyLastORNo: "",
        PropertyLastORDate: ""
      };

      this.$nextTick(() => {
        this.$v.$reset();
        this.$v.form.$touch();
      });
    },
    getProfileMe() {
      var self = this;
      self.isBusy = true;
      return new Promise(resolve => {
        let param = {};
        ApiService.get("profile/me", param)
          .then(({ data }) => {
            self.profile = data;
            self.form.FirstName = data.FirstName;
            self.form.LastName = data.LastName;
            self.form.ContactNumber = data.MetadataObject.ContactNumber;
            self.form.Email = data.EmailAddress;
            self.form.AddressStreet = data.MetadataObject.Address.Street;
            self.form.AddressCity = data.MetadataObject.Address.City;
            self.form.AddressProvince = data.MetadataObject.Address.Province;
            self.form.AddressZipCode = data.MetadataObject.Address.ZipCode;
            self.isBusy = false;
            window.scrollTo(0, 0);
            resolve(data);
            return data;
          })
          .catch(() => {
            self.profile = {};
            self.isBusy = false;
            window.scrollTo(0, 0);
          });
      });
    },
    postProfileUpdate() {
      let self = this;
      self.isBusy = true;
      //console.log("form:", self.$v.form);
      let param = {
        FirstName: self.$v.form.FirstName.$model,
        LastName: self.$v.form.LastName.$model,
        ContactNumber: self.$v.form.ContactNumber.$model,
        EmailAddress: self.$v.form.Email.$model,
        AddressStreet: self.$v.form.AddressStreet.$model,
        AddressCity: self.$v.form.AddressCity.$model,
        AddressProvince: self.$v.form.AddressProvince.$model,
        AddressZipCode: self.$v.form.AddressZipCode.$model,
        PropertyIdentificationNumber:
          self.$v.form.PropertyIdentificationNumber.$model,
        PropertyARPNo: self.$v.form.PropertyARPNo.$model,
        PropertyLastORNo: self.$v.form.PropertyLastORNo.$model,
        PropertyLastORDate: self.$v.form.PropertyLastORDate.$model
      };
      const submitButton = self.$refs["submit"];
      submitButton.classList.add("spinner", "spinner-light", "spinner-right");
      ApiService.post("profile/update", param)
        .then(({ data }) => {
          self.isBusy = false;
          submitButton.classList.remove(
            "spinner",
            "spinner-light",
            "spinner-right"
          );
          if (data)
            Swal.fire({
              title: "",
              text: "The application has been successfully submitted!",
              icon: "success",
              confirmButtonClass: "btn btn-secondary"
            });
          // this.$router.push({
          //   name: "dlro-doctors-details",
          //   params: { doctorId: data.DoctorId }
          // });
        })
        .catch(() => {
          self.isBusy = false;
          submitButton.classList.remove(
            "spinner",
            "spinner-light",
            "spinner-right"
          );
        });
    },
    submit: function(e) {
      e.preventDefault();
      this.postProfileUpdate();
    }
  }
};
</script>
